"use strict";
import { jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M6.53 8.47a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0-1.06-1.06L12 13.94z" }) });
export default SvgChevronDown;
